import React from "react";
import Service from "../helpers/service";
import $ from 'jquery';
import { API_URL, TRANSACTION_URL } from "../config/urls";

class Campaigns extends React.Component {
  componentDidMount() {
    console.log(this.props.match.params.id, "search");
    let campaign = this.props.match.params.id;

    if (campaign == "isl") {
      setInterval(() => {
        this.sendISLitem();
      }, 45000);
    }
    if (campaign == "cardano") {
      setInterval(() => {
        this.sendCardanoItem(campaign);
      }, 45000);
    }
    if (campaign == "cmc") {
      setInterval(() => {
        this.sendCardanoItem(campaign);
      }, 45000);
    }
    if (campaign == "nitro") {
      setInterval(() => {
        this.sendCardanoItem(campaign);
      }, 45000);
    }
  }

  sendCardanoItem = (campaign) => {
    Service.postCall(API_URL.ADMIN_TRADING_API + "assign-nft", { type: campaign })
      .then((response) => {
        console.log(response);
        $('div p').html(response.data.message);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.message);
          $('div p').html(error.response.data.message);
        }
      });
  };

  sendISLitem = () => {
    Service.postCall(TRANSACTION_URL + "isl-campaign-transaction")
      .then((response) => {
        console.log(response);
        $('div p').html(response.data.message);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.message)
          $('div p').html(error.response.data.message);
        }
      })
  }

  render() {
    return <div>
      <h2>Welcome Terra Virtua Campaigns</h2>
      <p></p>
    </div>;
  }
}

export default Campaigns;
